import React, {
  PropsWithChildren,
  createContext,
  useContext,
  useEffect,
  useRef,
} from "react";

import {onValue, ref} from "firebase/database";

import {realtimeDB} from "~/firebase/firebase";

const ServerTimeContext = createContext<(() => number) | null>(null);

export const ServerTimeProvider: React.FC<PropsWithChildren> = ({children}) => {
  const baseTimeRef = useRef({offset: 0, calibratedAt: performance.now()});

  useEffect(() => {
    const offsetRef = ref(realtimeDB, ".info/serverTimeOffset");

    const unsubscribe = onValue(offsetRef, (snapshot) => {
      const offsetVal = snapshot.val() || 0;
      baseTimeRef.current = {
        offset: offsetVal + Date.now(),
        calibratedAt: performance.now(),
      };
    });

    return () => unsubscribe();
  }, []);

  const getServerTime = () => {
    const now = performance.now();
    const {offset, calibratedAt} = baseTimeRef.current;
    return offset + (now - calibratedAt);
  };

  return (
    <ServerTimeContext.Provider value={getServerTime}>
      {children}
    </ServerTimeContext.Provider>
  );
};

export const useServerTime = () => {
  const ctx = useContext(ServerTimeContext);
  if (!ctx)
    throw new Error("useServerTime must be used inside ServerTimeProvider");
  return ctx;
};
